import { MyEmergencyPlanStep } from '@/features';

export const myEmergencyPlanSteps: MyEmergencyPlanStep[] = [
  {
    heroText: 'Every good plan has to start somewhere.',
    startStageId: 'G2',
  },
  {
    heroText: 'Emergencies can happen quickly – don’t wait for a warning before you act.',
    startStageId: 'REF8',
  },
  {
    heroText: 'Who else needs your protection?',
    startStageId: 'G3',
  },
  {
    heroText: 'Know where you’ll go, what you’ll take and how you’ll get there.',
    startStageId: 'G4',
  },
  {
    heroText: 'Fires move fast, so should you.',
    startStageId: 'G6',
  },
  {
    heroText: 'Now it’s time to think about severe weather.',
    startStageId: 'REFPRE31',
  },
  {
    heroText: 'Who needs to know your plan?',
    startStageId: 'G9',
  },
];
